import { Field, useFormikContext } from 'formik';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent, FormikCheckbox, FormikMultiSelect } from '../../../../../components/prime-formik';

const SuperMatchWorkplaceDetailsOfficeOnlyInput = ({ countryOptions, regionOptions }) => {
  const { values, setFieldValue, handleChange } = useFormikContext();

  return (
    <div className="margin-bottom-0-5">
      <FormattedMessage
        id="account.super-profiles.new.workplace-location.type.office-only"
        defaultMessage="Work at office only"
        tagName="label"
      >
        {(text) => (
          <Field
            name="workplaceDetailsType"
            checked={values.workplaceDetailsType === 'OFFICE_ONLY'}
            component={FormikCheckbox}
            setFieldValue={() => {
              setFieldValue('workplaceDetailsType', 'OFFICE_ONLY');
            }}
            labelText={text}
          />
        )}
      </FormattedMessage>
      {values.workplaceDetailsType === 'OFFICE_ONLY' && (
        <div className="mt10 margin-bottom-0-5 margin-left-1-5">
          <div className="margin-bottom-0-5">
            <div className="flex-space-between">
              <FormattedMessage
                id="account.super-profiles.new.workplace-location.select-country"
                defaultMessage="Select country"
              >
                {(text) => <label className="field-label">{text}</label>}
              </FormattedMessage>
              <FormattedMessage id="select" defaultMessage="Select">
                {(text) => (
                  <Field
                    name="workplaceDetailsOfficeOnlyCountry"
                    component={DropdownComponent}
                    options={countryOptions}
                    filter
                    filterBy="label,value"
                    className="right"
                    onChange={handleChange}
                    placeholder={`-- ${text} --`}
                    disabled={values.workplaceDetailsType !== 'OFFICE_ONLY'}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>
          <div className="flex-space-between">
            <FormattedMessage
              id="account.super-profiles.new.workplace-location.select-regions"
              defaultMessage="Select region(s)"
            >
              {(text) => <label className="field-label">{text}</label>}
            </FormattedMessage>
            <FormattedMessage id="select" defaultMessage="Select">
              {(text) => (
                <Field
                  name="workplaceDetailsOfficeOnlyRegions"
                  component={FormikMultiSelect}
                  options={regionOptions}
                  filter
                  filterBy="label,value"
                  className="right width-140"
                  onChange={handleChange}
                  placeholder={`-- ${text} --`}
                  disabled={values.workplaceDetailsType !== 'OFFICE_ONLY'}
                />
              )}
            </FormattedMessage>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperMatchWorkplaceDetailsOfficeOnlyInput;
